import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {
  equalStringValue,
  getStringValueNoEmpty,
  isEmptyString,
} from '../tools/string-tools';
import { EmpresaGuardValidators } from './empresa';

export class PathGuard {
  private constructor() {}

  public static readonly PATH_HOME = '/main/modules/show';
  /**
   * Verifica si la ruta es home o dashboard-wms
   * @param path - string - Ruta a verificar
   * @returns boolean - true si la ruta es home o dashboard-wms, false en caso contrario
   */
  static isHomeOrDashboardWms(path: string): boolean {
    return path.includes('home') || path.includes('dashboard-wms');
  }

  static getPathValue(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): string {
    return getStringValueNoEmpty(state.url, route.routeConfig?.path || '');
  }

  static getPathRedirectoTo(url: string, isMain: boolean = false): string {
    let path: string = this.PATH_HOME;
    const URL_WMS: string = '/wms';
    const URL_PUNTO_VENTA: string = '/punto-venta';
    const URL_SUMINISTROS: string = '/suministros';

    if (!isEmptyString(url) && !isMain) {
      if (EmpresaGuardValidators.validarWMS(url)) {
        path = equalStringValue(url, URL_WMS) ? this.PATH_HOME : URL_WMS;
      } else if (EmpresaGuardValidators.validarPuntoVenta(url)) {
        path = equalStringValue(url, URL_PUNTO_VENTA)
          ? this.PATH_HOME
          : URL_PUNTO_VENTA;
      } else if (EmpresaGuardValidators.validarSuministros(url)) {
        path = equalStringValue(url, URL_SUMINISTROS)
          ? this.PATH_HOME
          : URL_SUMINISTROS;
      }
    }
    return getStringValueNoEmpty(path, '');
  }

  /**
   * Verifica si la url no pertenece a ninguno de los módulos (WMS, Punto de Venta, Suministros)
   * @param url - string - Url a verificar
   * @returns boolean - true si la url es del área principal, false si pertenece a un módulo
   */
  static getMainRoute(url: string): boolean {
    return (
      !EmpresaGuardValidators.validarWMS(url) &&
      !EmpresaGuardValidators.validarPuntoVenta(url) &&
      !EmpresaGuardValidators.validarSuministros(url)
    );
  }
}
